export const FETCH_WHAT_INCLUDES_DATA_INIT = 'FETCH_WHAT_INCLUDES_DATA_INIT';
export const FETCH_WHAT_INCLUDES_DATA_SUCCESS = 'FETCH_WHAT_INCLUDES_DATA_SUCCESS';
export const FETCH_WHAT_INCLUDES_DATA_ERROR = 'FETCH_WHAT_INCLUDES_DATA_ERROR';
export const CLEAR_WHAT_INCLUDES_DATA = 'CLEAR_WHAT_INCLUDES_DATA'
